<template>
  <div class="view view__store POS-r">
    <loader v-if="showLoader"></loader>
    <div class="row no-gutters justify-content-center">
      <div class="col col-md-6 col-lg-4">
        <navigation
          :class="{ 'is-mini': miniNavigation }"
          v-on:select-user="showUserPanel = !showUserPanel"
          :logo="store.logo"
          :prev="navigatePrev"
          :disable-user="wdOrder"
        ></navigation>

        <user-panel
          v-if="showUserPanel"
          v-body-scroll-lock="showUserPanel"
          v-on:close="showUserPanel = false"
        ></user-panel>

        <div
          class="group-banner MR-m ML-m PT-m PR-l PB-m PL-l BGC-brand BDRS-99 FZ-14 CU-p ACTIVE-small"
          v-if="currentGroup.id && !wdOrder"
          v-on:click="showGroup = true"
        >
          <template v-if="wdOrder">
            <span class="icon material-icons-round MR-l">table_bar</span>
            <div class="content">
              {{ $t('store.now') }}：{{ currentGroup.host }}
            </div>
            <span class="more material-icons-round ML-l C-dark-50">arrow_right_alt</span>
          </template>
          <template v-else>
            <span class="icon material-icons-round MR-l">group_add</span>
            <div class="content LH-125">
              <div class="FW-b">{{ currentGroup.owner ? $t('store.groupOrdering') : $t('store.participating{name}', { name: currentGroup.host }) }}</div>
              <div class="FZ-12">#{{ currentGroup.id }}</div>
            </div>
            <span class="more material-icons-round ML-l C-dark-50">arrow_right_alt</span>
          </template>
        </div>

        <div
          class="group-banner MR-m ML-m PT-m PR-l PB-m PL-l BGC-brand BDRS-99 FZ-14 CU-p ACTIVE-small"
          v-if="currentGroup.id && wdOrder"
          v-on:click="goWdOrder()"
        >
          <span class="icon material-icons-round MR-l">table_bar</span>
          <div class="content">
            {{ $t('store.now') }}：{{ currentGroup.host }}
          </div>
          <span class="more material-icons-round ML-l C-dark-50">arrow_right_alt</span>
        </div>

        <div
          class="store__banner POS-a OV-h BDRS-tl-m BDRS-tr-m BGC-light"
          :class="{ 'is-shifted': currentGroup.id }"
        >
          <div class="POS-a TRBL-0 BGR-n BGP-c-c BGZ-c" :style="'background-image: url(' + store.banner + ')'"></div>
          <div class="store__banner-overlay POS-a BDRS-tl-m BDRS-tr-m BGC-white"></div>
        </div>
        <div class="store__header">
          <img
            :src="store.logo"
            :alt="store.name"
            class="BDRS-100 store__logo MR-a ML-a MB-m D-b"
          >
          <div
            class="store__name PR-s PL-s TA-c FW-b FZ-24"
            v-waypoint="{ active: true, callback: nameWaypoint }"
          >{{ store.name }}</div>
          <div class="store__branch TA-c C-grey">
            <span class="VA-m" v-if="store.branch">{{ store.branch }}</span>
          </div>
          <div class="store__branch MT-s MB-s" v-if="showStoreHeader">
            <button
              class="MR-xxs ML-xxs PT-xs PR-m PB-xs PL-m BDRS-99 BGC-light C-grey FZ-12 FW-b BUTTON-reset ACTIVE-small"
              v-on:click="showInfo = !showInfo"
            >{{ $t('store.storeInformation') }}</button>
            <button
              class="MR-xxs ML-xxs PT-xs PR-m PB-xs PL-m BDRS-99 BGC-light C-grey FZ-12 FW-b BUTTON-reset ACTIVE-small"
              v-on:click="showGroup = true"
              v-if="!readonly && store.order_setting.groupOrder"
            >{{ $t('store.groupOrder') }}</button>
          </div>
          <a
            class="store__info MT-s MR-m MB-s ML-m P-m BDRS-99 BGC-light ACTIVE-small CU-p"
            v-show="showInfo"
            :href="'https://maps.google.com/?q=' + store.address"
            target="_blank"
          >
            <span class="material-icons-round VA-m MR-m">place</span>
            <div class="text">{{ store.address }}</div>
          </a>
          <a
            class="store__info MT-s MR-m MB-m ML-m P-m BDRS-99 BGC-light ACTIVE-small"
            v-show="showInfo"
            :href="'tel:' + store.tel"
          >
            <span class="material-icons-round VA-m MR-m">phone</span>
            <div class="text">{{ store.tel }}</div>
          </a>
        </div>

        <template v-if="showOrderTool && !readonly">
          <div class="order__type M-m MT-xl">
            <div
              class="store__info__tab"
              :class="{ 'is-fixed': fixOrderType }"
            >
              <tab-item
                class="tab MR-xxs ML-xxs F-1"
                :class="{ 'is-active': selectedOrderType === 'DELIVERY' }"
                v-on:click.native="selectOrderType('DELIVERY')"
                v-if="store.order_setting && store.order_setting.DELIVERY"
              >
                <template v-slot:icon>
                  <span class="material-icons-round">meeting_room</span>
                </template>
                <template v-slot:label>
                  {{ store.order_setting.DELIVERY.label || $t('store.delivery') }}
                </template>
              </tab-item>
              <tab-item
                class="tab MR-xxs ML-xxs F-1"
                :class="{ 'is-active': selectedOrderType === 'PICKUP' }"
                v-on:click.native="selectOrderType('PICKUP')"
                v-if="store.order_setting && store.order_setting.PICKUP"
              >
                <template v-slot:icon>
                  <span class="material-icons-round">local_mall</span>
                </template>
                <template v-slot:label>
                  {{ store.order_setting.PICKUP.label || $t('store.pickup') }}
                </template>
              </tab-item>
              <tab-item
                class="tab MR-xxs ML-xxs F-1"
                :class="{ 'is-active': selectedOrderType === 'INSTORE' }"
                v-on:click.native="selectOrderType('INSTORE')"
                v-if="store.order_setting && store.order_setting.INSTORE"
              >
                <template v-slot:icon>
                  <span class="material-icons-round">store</span>
                </template>
                <template v-slot:label>
                  {{ store.order_setting.INSTORE.label || $t('store.inStore') }}
                </template>
              </tab-item>
            </div>
          </div>

          <!-- DELIVERY -->
          <div
            class="order__delivery M-m"
            v-if="selectedOrderType === 'DELIVERY'"
          >
            <custom-select
              id="selected-delivery-time"
              class="c-select MB-s"
              :options="store.order_setting.DELIVERY.orderTimeList"
              v-model="selectedOrderTime"
              :label="$t('store.orderType')"
            >
              <template v-slot:icon>
                <span class="material-icons-round icon MR-m">access_time</span>
              </template>
            </custom-select>
            <transition name="animation-fade">
              <div
                class="row no-gutters MB-s"
                v-if="selectedOrderTime === 'SCHEDULED'"
              >
                <div class="col MR-xxs">
                  <custom-select
                    id="selected-date"
                    :options="store.order_setting.DELIVERY.date"
                    v-model="selectedDate"
                    :label="$t('store.date')"
                    :labelFunction="dateLabel"
                  >
                    <template v-slot:icon>
                      <span class="material-icons-round icon MR-m">event_note</span>
                    </template>
                  </custom-select>
                </div>
                <div class="col ML-xxs">
                  <custom-select
                    id="selected-time"
                    :options="store.order_setting.DELIVERY.time"
                    v-model="selectedTime"
                    :label="$t('store.time')"
                  >
                  </custom-select>
                </div>
              </div>
            </transition>
            <custom-input
              id="street-address"
              type="text"
              class="MB-s"
              :label="$t('store.address')"
              :placeholder="`${$t('store.address')}（${$t('store.excludingFloor')}）`"
              v-model.trim="streetAddress"
              :has-error="streetAddressError"
              required="required"
              v-bind="$attrs"
              autocomplete="off"
              autocorrect="off"
              autocapitalize="off"
              spellcheck="false"
            >
              <template v-slot:icon>
                <span class="material-icons-round icon MR-m">home</span>
              </template>
            </custom-input>
            <div
              class="fill-address MT-m MB-m ML-m"
              v-if="selectedOrderType === 'DELIVERY' && !streetAddress && user.savedAddress.length > 0"
            >
              <span
                class="D-ib MR-s FZ-12 C-grey FW-b"
              >{{ $t('store.addressHistory') }}</span>
              <div
                class="address-item PT-xs PR-s PB-xs PL-s MR-s D-ib BDRS-99 BGC-light FZ-14 C-dark ACTIVE-small"
                v-for="(address, index) in user.savedAddress"
                v-bind:key="'address#' + index"
                v-on:click="fillAddress(address)"
              >
                <template v-if="address.floor">
                  {{ address.street }}，{{ address.floor }}
                </template>
                <template v-else>
                  {{ address.street }}
                </template>
              </div>
            </div>
            <div
              class="delivery-fee POS-r MT-m P-m BDRS-s BGC-white"
              :class="{ 'too-far': currentOrder.delivery.distance === -1, 'free-of-charge': !store.order_setting.DELIVERY.chargeDeliveryFee }"
              v-show="streetAddress && !streetAddressError && (currentLocale === 'en' || streetAddress.length > 5)"
            >
              <template v-if="currentOrder.delivery.distance === -1">
                <span class="material-icons-round icon MR-m C-notice">warning</span>
                <div class="info FZ-14 LH-140 FW-b C-notice">
                  {{ $t('store.warnText') }}
                </div>
              </template>
              <template v-else>
                <span class="material-icons-round icon MR-m">local_atm</span>
                <div class="info FZ-14 LH-140">
                  <div class="fee FW-b LH-140" v-if="currentOrder.delivery.fee === 0"> {{ $t('store.free') }}</div>
                  <template v-else>
                    <template v-if="currentOrder.delivery.discount > 0">
                      <div class="fee FW-b LH-140">{{ $t('store.shippingFee') }} ${{ Number(currentOrder.delivery.fee).toLocaleString() }}（{{ $t('store.discount') }} ${{ Number(currentOrder.delivery.discount).toLocaleString() }}）</div>
                    </template>
                    <template v-else>
                      <div class="fee FW-b LH-140">{{ $t('store.shippingFee') }} ${{ Number(currentOrder.delivery.fee).toLocaleString() }}</div>
                    </template>
                  </template>
                  <template v-if="currentOrder.delivery.fee > 0">
                    <div class="desc FW-n FZ-12 LH-140 C-grey">
                      <span>{{ $t('store.route') }} {{ parseDistance(currentOrder.delivery.distance) }}</span>
                      <span v-if="currentOrder.delivery.minimum">{{ $t('store.amount') }} ${{ Number(currentOrder.delivery.minimum).toLocaleString() }}</span>
                      <span v-if="currentOrder.delivery.freeDelivery">{{ $t('store.reeShippingText{num}', {
                        num: Number(currentOrder.delivery.freeDelivery).toLocaleString()
                      }) }}</span>
                    </div>
                  </template>
                </div>
              </template>
              <div class="loader" v-if="deliveryFeeLoading"><span></span><span></span><span></span></div>
            </div>
            <div
              class="delivery-wait-time POS-r MT-m P-m BDRS-s BGC-white"
              v-show="selectedOrderTime === 'ASAP' && streetAddress && !streetAddressError && (currentLocale === 'en' || streetAddress.length > 5)"
            >
              <template>
                <span class="material-icons-round icon MR-m">alarm</span>
                <div class="info FZ-14 LH-140">
                  <div class="fee FW-b LH-140">
                    {{ $t('store.waitTimeEstimate{num}', { num: currentOrder.delivery.waitTime ?? store.detail?.waitTime }) }}
                  </div>
                  <div class="desc FW-n FZ-12 LH-140 C-grey">
                    <span>{{ $t('store.waitTimeNotice') }}</span>
                  </div>
                </div>
              </template>
              <div class="loader" v-if="deliveryFeeLoading"><span></span><span></span><span></span></div>
            </div>
          </div>

          <!-- PICKUP -->
          <div
            class="order__delivery M-m"
            v-if="selectedOrderType === 'PICKUP'"
          >
            <custom-select
              id="selected-delivery-time"
              class="c-select MB-s"
              :options="store.order_setting.PICKUP.orderTimeList"
              v-model="selectedOrderTime"
              :label="$t('store.orderType')"
            >
              <template v-slot:icon>
                <span class="material-icons-round icon MR-m">access_time</span>
              </template>
            </custom-select>
            <transition name="animation-fade">
              <div
                class="row no-gutters MB-s"
                v-if="selectedOrderTime === 'SCHEDULED'"
              >
                <div class="col MR-xxs">
                  <custom-select
                    id="selected-date"
                    :options="store.order_setting.PICKUP.date"
                    v-model="selectedDate"
                    :label="$t('store.date')"
                    :select-first="true"
                    :labelFunction="dateLabel"
                  >
                    <template v-slot:icon>
                      <span class="material-icons-round icon MR-m">event_note</span>
                    </template>
                  </custom-select>
                </div>
                <div class="col ML-xxs">
                  <custom-select
                    id="selected-time"
                    :options="store.order_setting.PICKUP.time"
                    v-model="selectedTime"
                    :label="$t('store.time')"
                  >
                  </custom-select>
                </div>
              </div>
            </transition>
            <div
              class="delivery-wait-time POS-r MT-m P-m BDRS-s BGC-white"
              v-show="selectedOrderTime === 'ASAP'"
            >
              <template>
                <span class="material-icons-round icon MR-m">alarm</span>
                <div class="info FZ-14 LH-140">
                  <div class="fee FW-b LH-140">
                    {{ $t('store.waitTimeEstimate{num}', { num: currentOrder.detail?.waitTime ?? store.waitTime }) }}
                  </div>
                  <div class="desc FW-n FZ-12 LH-140 C-grey">
                    <span>{{ $t('store.waitTimeNotice') }}</span>
                  </div>
                </div>
              </template>
              <div class="loader" v-if="deliveryFeeLoading"><span></span><span></span><span></span></div>
            </div>
          </div>

          <!-- INSTORE -->
          <div
            class="order__delivery M-m"
            v-if="selectedOrderType === 'INSTORE'"
          >
            <custom-select
              id="selected-delivery-time"
              class="c-select MB-s"
              :options="store.order_setting.INSTORE.orderTimeList"
              v-model="selectedOrderTime"
              :label="$t('store.orderType')"
            >
              <template v-slot:icon>
                <span class="material-icons-round icon MR-m">access_time</span>
              </template>
            </custom-select>
            <transition name="animation-fade">
              <div
                class="row no-gutters MB-s"
                v-if="selectedOrderTime === 'SCHEDULED'"
              >
                <div class="col MR-xxs">
                  <custom-select
                    id="selected-date"
                    :options="store.order_setting.INSTORE.date"
                    v-model="selectedDate"
                    :label="$t('store.date')"
                    :select-first="true"
                    :labelFunction="dateLabel"
                  >
                    <template v-slot:icon>
                      <span class="material-icons-round icon MR-m">event_note</span>
                    </template>
                  </custom-select>
                </div>
                <div class="col ML-xxs">
                  <custom-select
                    id="selected-time"
                    :options="store.order_setting.INSTORE.time"
                    v-model="selectedTime"
                    :label="$t('store.time')"
                  >
                  </custom-select>
                </div>
              </div>
            </transition>
          </div>
        </template>

        <div
          class="store__info__announce M-m MB-s"
          v-if="store.order_setting.announce"
        >
          <div class="announce-title MT-l MR-l ML-l FW-b">
            <span class="material-icons-round MR-xs">info</span>
            <span>{{ $t('store.notices') }}</span>
          </div>
          <vue-markdown
            class="announce-content MT-s MR-l MB-m ML-l FZ-14"
            :source="store.order_setting.announce"
            :anchor-attributes="{ target: '_blank', rel: 'nofollow' }"
          />
          <div
            class="MB-l TA-c"
          >
            <button
              class="more PT-xs PR-m PB-xs PL-m BDRS-s BGC-light C-grey FW-b FZ-12 ACTIVE-small BUTTON-reset"
              v-on:click="showAnnounce = true"
            >{{ $t('store.learnMore') }}</button>
          </div>
        </div>

        <swiper
          class="promos"
          :options="promosSwiperOptions"
          v-if="promos.length !== 0"
          v-on:click-slide="selectPromo"
        >
          <swiper-slide
            class="promo"
            :class="{ 'has-multi': promos.length > 1 }"
            v-for="promo in promos"
            v-bind:key="'promo#' + promo.id"
          >
            <div class="promo-container MT-s MR-m MB-s ML-m BDRS-m BGC-brand OV-h">
              <div class="promo-title MT-l MR-l ML-l FW-b">
                <span class="material-icons-round MR-xs">campaign</span>
                <span>{{ promo.title }}</span>
              </div>
              <div class="promo-content MR-l MB-l ML-l PT-s FZ-14">{{ promo.content }}</div>
            </div>
          </swiper-slide>
          <div class="promos-pagination swiper-pagination" slot="pagination" v-show="promos.length > 1"></div>
        </swiper>

        <div
          class="disabled-hours M-m P-m BDRS-s BGC-white FZ-14 FW-b C-notice"
          v-if="disabledOrderHours && disabledOrderHours.length > 0"
        ><!--
          -->{{ $t('cart.unavailable') }}
          <ul class="MB-0">
            <li v-for="hours in disabledOrderHours" :key="hours">{{ hours }}</li>
          </ul>
        </div>

        <div
          class="store__info__desc MT-s MR-m MB-s ML-m P-l BDRS-m BGC-light FZ-14"
          v-if="selectedOrderType === 'DELIVERY' && store.order_setting.DELIVERY.notice"
          v-html="store.order_setting.DELIVERY.notice"
        ></div>
        <div
          class="store__info__desc MT-s MR-m MB-s ML-m P-l BDRS-m BGC-light FZ-14"
          v-if="selectedOrderType === 'PICKUP' && store.order_setting.PICKUP.notice"
        ><!--
          -->{{ store.order_setting.PICKUP.notice }}
        </div><div
          class="store__info__desc MT-s MR-m MB-s ML-m P-l BDRS-m BGC-light FZ-14"
          v-if="selectedOrderType === 'INSTORE' && store.order_setting.INSTORE.notice"
        ><!--
          -->{{ store.order_setting.INSTORE.notice }}
        </div>

        <transition name="animation-fade">
          <div
            ref="categories"
            class="store__categories POS-f"
            :class="{ 'is-shifted': !miniNavigation }"
            v-show="products && showCategories"
          >
            <div class="row no-gutters justify-content-center">
              <div class="col col-md-6 col-lg-4 POS-r">
                <ul ref="storeCategoriesWrapper" class="store__categories__wrapper M-0 P-0">
                  <li
                    class="store__categories__item POS-r FZ-14 C-grey"
                    v-scroll-to="{ element: '.view' }"
                  >{{ $t('store.backToTop') }}</li>
                  <li
                    :id="'category-pill-' + category.id"
                    :ref="'categoryPill#' + category.id"
                    class="store__categories__item POS-r FZ-14 C-grey"
                    :class="{ 'is-current': currentCategory.replace('Category-', '') === category.id }"
                    v-for="category in products"
                    v-bind:key="'category-pill#' + category.id"
                    v-on:click="selectCategoryPill(category.id)"
                  >{{ category.name }}</li>
                </ul>
              </div>
            </div>
          </div>
        </transition>

        <div
          class="store__menu MT-m MB-m"
          v-if="products"
        >
          <div class="view-tools M-m">
            <form
              class="search-form"
              action
              v-on:keyup.enter="$event.target.blur()"
              v-on:submit.prevent
            >
              <custom-input
                type="search MR-xxs"
                class="MB-0"
                :label="$t('store.search')"
                v-model.trim="keyword"
                v-bind="$attrs"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
                :clearable="true"
              >
                <template v-slot:icon>
                  <span class="material-icons-round icon MR-m">search</span>
                </template>
              </custom-input>
            </form>
            <div class="D-f ML-xxs BGC-light BDRS-s">
              <button
                :class="{ 'C-grey': menuView === 'LIST', 'C-light-grey': menuView !== 'LIST' }"
                class="MR-s ML-s BGC-t FZ-12 FW-b ACTIVE-small BUTTON-reset"
                v-on:click="menuView = 'LIST'"
              ><span class="material-icons-round icon">view_agenda</span></button>
              <button
                :class="{ 'C-grey': menuView === 'GRID', 'C-light-grey': menuView !== 'GRID' }"
                class="MR-s ML-s BGC-t FZ-12 FW-b ACTIVE-small BUTTON-reset"
                v-on:click="menuView = 'GRID'"
              ><span class="material-icons-round icon">grid_view</span></button>
            </div>
          </div>
          <template
            v-for="category in filteredProducts"
          >
            <div
              class="MT-l MB-m"
              v-bind:key="'category#' + category.id"
              v-if="category.id"
            >
              <div class="store__category-header">
                <div
                  :id="'Category-' + category.id"
                  class="section-title store__category-title MT-xxl PR-xl PL-xl FZ-18"
                >{{ category.name }}</div>
                <div class="section-sub-title PR-xl PL-xl FZ-15" v-if="category.desc">{{ category.desc }}</div>
                <div
                  :data-id="'Category-' + category.id"
                  v-waypoint="{ active: categoryWaypointActive, callback: categoryStartWaypoint, options: categoryStartWaypointOptions }"
                ></div>
              </div>
              <div class="store__products" :class="{ 'store__products--list': menuView === 'LIST', 'store__products--grid': menuView === 'GRID' }">
                <product-item
                  class="store__product POS-r PT-s PR-m PB-s PL-m BDRS-m"
                  v-for="product in category.items"
                  v-bind:key="'product#' + product.id"
                  :product="product"
                  :amount="itemCount(product)"
                  v-on:click.native="selectProduct(product)"
                  :layout="menuView"
                ></product-item>
              </div>
              <div
                :data-id="'Category-' + category.id"
                v-waypoint="{ active: categoryWaypointActive, callback: categoryEndWaypoint, options: categoryEndWaypointOptions }"
              ></div>
            </div>
          </template>
        </div>

        <div class="ocard MT-xl P-m TA-c FZ-12 LH-140 C-grey">
          <img class="D-b ML-a MR-a MB-m" src="https://ocard.co/assets/img/powered-by.svg" alt="Powered by Ocard">
          <template v-if="store.companyName && store.companyNo">
            {{ store.companyName }}<br>
          </template>
          <template v-if="store.companyNo && store.companyNo">
            {{ $t('store.taxID') }} {{ store.companyNo }}<br>
          </template>
          {{ $t('store.serviceProvided{name}', { name: store.name }) }}
          <div class="terms MT-xxs MB-xxs">
            <a href="https://ocard.co/privacy" target="blank">{{ $t('userPanel.privacyPolicy') }}</a>・<a href="https://ocard.co/terms" target="blank">{{ $t('userPanel.terms') }}</a>
          </div>
          {{ VUE_APP_VERSION }}
        </div>

        <div
          class="footer POS-s"
          v-if="readOnlyFor || readonly"
        >
          <div class="readonly-for" v-if="readOnlyFor">{{ readOnlyFor }}</div>
          <div class="readonly-for" v-else>{{ $t('store.readOnly') }}</div>
        </div>

        <transition name="animation-slide-in-bottom">
          <div
            class="footer POS-s P-s"
            v-if="showCheckout() && !wdOrder"
          >
            <yellow-button
              class="go-to-cart MB-s ACTIVE-small"
              :label="$t('store.viewCart')"
              v-on:click.native="goToCart(currentOrder.id)"
              :is-loading="orderUpdating || deliveryFeeLoading"
            >
              <template v-slot:right>
                <span class="right">${{ Number(currentOrder.detail.subtotal || 0).toLocaleString() }}</span>
              </template>
            </yellow-button>
          </div>
        </transition>

        <div
          class="footer POS-s P-s"
          v-if="wdOrder"
        >
          <yellow-button
            class="go-to-cart MB-s ACTIVE-small"
            :label="$t('store.viewCart')"
            v-on:click.native="goWdOrder()"
            :is-loading="orderUpdating || deliveryFeeLoading"
          >
            <template v-slot:right>
              <span class="right">${{ Number(currentOrder.detail.subtotal || 0).toLocaleString() }}</span>
            </template>
          </yellow-button>
        </div>

        <product-modal
          v-if="productModalProduct"
          :readonly="readonly"
          :via="'store'"
          :product="productModalProduct"
          :order-time="productOrderTime"
          :order-type="selectedOrderType"
          v-body-scroll-lock="productModalProduct"
          v-on:close="productModalProduct = null"
        >
        </product-modal>

        <announce
          v-if="showAnnounce"
          v-body-scroll-lock="showAnnounce"
          :announce="store.order_setting.announce"
          v-on:close="showAnnounce = false"
        />

        <group
          v-if="showGroup"
          v-body-scroll-lock="showGroup"
          v-on:close="showGroup = false"
          :order="currentGroup.id"
          :orderType="selectedOrderType"
          :orderTime="productOrderTime"
          :isGroupOrders="!!currentGroup.id"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import i18n from '@/i18n/index';
import { mapState, mapMutations, mapActions } from 'vuex';
// import BodyScrollLock from '@/helpers/body-scroll-lock';
import VueAnimate from 'vue-animate-scroll';
import VueScrollTo from 'vue-scrollto';
import Axios from '@/helpers/axios';
import { verifyAddress } from '@/helpers/validator';
import Swal from 'sweetalert2';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import ClipboardJS from 'clipboard';
import VueMarkdown from 'vue-markdown';

import loader from '@/components/UI/Loader.vue';
import navigation from '@/components/Navigation.vue';
import userPanel from '@/components/UserPanel.vue';
import tabItem from '@/components/UI/TabItem.vue';
import productItem from '@/components/ProductItem.vue';
import productModal from '@/components/ProductModal.vue';
import customSelect from '@/components/form/Select.vue';
import customInput from '@/components/form/Input.vue';
import yellowButton from '@/components/form/YellowButton.vue';
import announce from '@/components/Announce.vue';
import group from '@/components/Group.vue';

Vue.use(VueAnimate);
Vue.use(VueScrollTo, {
  duration: 250,
  easing: [0.4, 0, 0.2, 1],
});

export default {
  name: 'Store',
  components: {
    loader,
    navigation,
    userPanel,
    tabItem,
    productItem,
    productModal,
    customSelect,
    customInput,
    yellowButton,
    Swiper,
    SwiperSlide,
    VueMarkdown,
    announce,
    group,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      showLoader: true,

      storeLoaded: false,
      storeUpdating: false,
      orderUpdating: false,
      orderLoaded: false,
      miniNavigation: false,

      showUserPanel: false,

      showAnnounce: false,
      showInfo: false,
      selectedOrderType: null,
      selectedOrderTime: null,

      selectedDate: null,
      selectedTime: null,

      streetAddress: null,
      streetAddressError: false,
      floorAddress: null,

      deliveryFeeLoading: false,

      keyword: null,
      menuView: 'LIST',

      showCategories: false,

      showProductModal: true,
      productModalProduct: null,

      categoryWaypointActive: true,
      categoryWaypointScrolling: false,
      categoryStartWaypointOptions: {
        root: null,
        rootMargin: '0px 0px -20% 0px',
        threshold: [1.0, 1.0],
      },
      categoryEndWaypointOptions: {
        root: null,
        rootMargin: '-20% 0px 0px 0px',
        threshold: [1.0, 1.0],
      },
      currentCategory: '',
      categoryScroller: null,

      promosSwiperOptions: {
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true,
        },
      },

      showGroup: false,

      groupOrder: '',
      currentLocale: i18n.locale,
    };
  },
  computed: {
    ...mapState([
      'user',
      'vip',
      'store',
      'products',
      'readOnlyFor',
      'promos',
      'cart',
      'savedCartId',
      'currentOrder',
      'savedOrders',
      'currentGroup',
    ]),
    showStoreHeader() {
      return !('hideStoreHeader' in this.$route.query);
    },
    showOrderTool() {
      return !('hideOrderTool' in this.$route.query) && !(this.currentGroup.id && !this.currentGroup.owner);
    },
    disabledOrderHours() {
      if (this.selectedOrderTime === 'SCHEDULED') {
        return this.store.order_setting[this.selectedOrderType].time.filter((time) => time.disable === true).map((time) => time.label);
      }

      return null;
    },
    fixOrderType() {
      return 'fixOrderType' in this.$route.query || (this.currentOrder.property && this.currentOrder.property.fixOrderType);
    },
    readonly() {
      return this.readOnlyFor || 'readonly' in this.$route.query;
    },
    productOrderTime() {
      if (this.selectedOrderTime === 'SCHEDULED' && this.selectedDate && this.selectedTime) {
        return `${this.selectedDate} ${this.selectedTime}`;
      }

      return null;
    },
    VUE_APP_VERSION() {
      return this.$store.state.VUE_APP_VERSION;
    },
    filteredProducts() {
      if (!this.keyword) {
        return this.products;
      }

      return this.products.map((product) => {
        const tempProduct = {};
        const keyword = this.keyword.toLowerCase();
        const filteredItem = product.items.filter((item) => item.name.toLowerCase().includes(keyword) || (item.desc && item.desc.toLowerCase().includes(keyword)));

        tempProduct.desc = product.desc;
        tempProduct.id = product.id;
        tempProduct.name = product.name;
        tempProduct.items = filteredItem;

        return tempProduct.items.length > 0 ? tempProduct : false;
      });
    },
    wdOrder() {
      return 'wdOrder' in this.$route.query;
    },
    queryShowGroup() {
      return 'showGroup' in this.$route.query;
    },
  },
  watch: {
    store: {
      handler(newVal, oldVal) {
        if (
          newVal.order_setting.announce !== oldVal.order_setting.announce
          && newVal.order_setting.announce !== null
        ) {
          this.showAnnounce = true;
        }
        this.selectedTime = newVal.order_setting[this.selectedOrderType]?.time[0].value;
      },
      deep: true,
    },
    selectedOrderType(type) {
      if (!this.storeLoaded) {
        return;
      }

      this.streetAddress = null;

      this.getMenu();

      // eslint-disable-next-line prefer-destructuring
      this.selectedOrderTime = this.store.order_setting[type].orderTime[0];

      if (this.selectedOrderTime === 'SCHEDULED') {
        this.selectedDate = this.store.order_setting[type].date[0].value;
        this.selectedTime = this.store.order_setting[type]?.time[0].value;
      }

      if (this.currentOrder.id) {
        this.updateOrder();
      }
    },
    selectedOrderTime(time) {
      if (!this.storeLoaded || this.storeUpdating) {
        return;
      }

      if (time === 'SCHEDULED') {
        this.selectedDate = this.store.order_setting[this.selectedOrderType].date[0].value;
        this.selectedTime = this.store.order_setting[this.selectedOrderType].time.filter((timeOption) => timeOption.disable === undefined)[0].value;
      }

      this.getMenu();

      if (this.currentOrder.id) {
        this.updateOrder();
      }
    },
    currentCategory(newVal) {
      if (!this.showCategories) {
        return;
      }

      if (this.categoryWaypointScrolling) {
        return;
      }

      const id = newVal.replace('Category-', '');

      if (!this.$refs[`categoryPill#${id}`]) {
        return;
      }

      const categoriesOffset = this.$refs.storeCategoriesWrapper.offsetWidth / 2;
      const pillOffset = this.$refs[`categoryPill#${id}`][0].offsetWidth / 2;

      const options = {
        container: '.store__categories__wrapper',
        duration: 250,
        offset: 0 - categoriesOffset + pillOffset,
        x: true,
        y: false,
        onStart: () => {
          this.categoryWaypointScrolling = true;
        },
        onDone: () => {
          this.categoryWaypointScrolling = false;
        },
      };

      VueScrollTo.scrollTo(`#category-pill-${id}`, 250, options);
    },
    selectedDate(newVal) {
      if (!this.storeLoaded || this.storeUpdating) {
        return;
      }

      this.storeUpdating = true;
      this.selectedTime = null;
      this.$store.dispatch('GET_STORE_HOURS', {
        ...this.$route.query,
        brand_id: this.$route.params.brandId,
        storeId: this.$route.params.storeId,
        orderType: this.selectedOrderType,
        date: newVal,
      });
      this.$nextTick(() => {
        this.storeUpdating = false;
      });
    },
    selectedTime() {
      if (!this.storeLoaded || this.storeUpdating) {
        return;
      }

      this.getMenu();

      if (this.currentOrder.id) {
        this.updateOrder();
      }

      if (this.selectedOrderType === 'DELIVERY') {
        this.getDeliveryFee();
      }
    },
    streetAddress(newVal) {
      if (!this.storeLoaded || this.storeUpdating) {
        return;
      }

      this.streetAddressError = verifyAddress(newVal);

      this.getDeliveryFee();
    },
    keyword(newVal) {
      if (newVal !== null || newVal !== '') this.showCategories = false;
    },
    products() {
      this.setMenuView();
    },
  },
  mounted() {
    if (this.queryShowGroup) {
      this.showGroup = true;
    }
  },
  methods: {
    ...mapMutations([
      'SET_CURRENT_ORDER',
      'SET_CURRENT_ORDER_DELIVERY',
      'RESET_CURRENT_ORDER_DELIVERY',
      'REMOVE_FROM_SAVED_ORDERS',
      'RESET_CURRENT_ORDER',
      'SET_CURRENT_GROUP',
      'RESET_CURRENT_GROUP',
      'RESET_PRODUCTS',
      'SET_CART',
      'RESET_CART',
      'SET_STORE',
    ]),
    ...mapActions([
      'GET_STORE',
      'GET_STORE_HOURS',
      'GET_PRODUCTS',
    ]),
    navigatePrev() {
      this.$router.push({ name: 'Brand', params: { brandId: this.$route.params.brandId } });
    },
    getMenu() {
      this.showLoader = true;

      const data = {
        brand_id: this.$route.params.brandId,
        storeId: this.$route.params.storeId,
        orderType: this.selectedOrderType,
      };

      data.query = this.$route.query;

      if (this.currentOrder.id && this.$route.params.brandId === this.currentOrder.brand && this.$route.params.storeId === this.currentOrder.store) {
        data.orderId = this.currentOrder.id;
      }

      if (this.selectedOrderTime === 'SCHEDULED') {
        data.time = `${this.selectedDate} ${this.selectedTime}`;
      }

      this.GET_PRODUCTS(data);

      this.$nextTick(() => {
        this.showLoader = false;
        this.storeLoading = false;

        if (this.$route.query.prefill) this.prefill();
      });
    },
    setMenuView() {
      // 超過 1/2 商品有圖，設定為 GRID 版面
      let productCount = 0;
      let productHasImageCount = 0;

      this.products.forEach((category) => {
        category.items.forEach((product) => {
          productCount += 1;
          if (product.image) productHasImageCount += 1;
        });
      });

      if (productHasImageCount > (productCount / 2)) {
        this.menuView = 'GRID';
      } else {
        this.menuView = 'LIST';
      }
    },
    prefill() {
      const prefillData = this.$route.query.prefill.split(';');

      prefillData.forEach((prefill) => {
        const splited = prefill.split('|');
        // eslint-disable-next-line prefer-destructuring
        if (splited[0] in this) this[splited[0]] = splited[1];
      });
    },
    nameWaypoint({ going, direction }) {
      if (going === this.$waypointMap.GOING_OUT && direction === this.$waypointMap.DIRECTION_TOP) {
        this.miniNavigation = true;
      } else if (going === this.$waypointMap.GOING_IN && direction === this.$waypointMap.DIRECTION_BOTTOM) {
        this.miniNavigation = false;
        this.showCategories = false;
      }
    },
    fillAddress(address) {
      this.floorAddress = address.floor;
      this.streetAddress = address.street;
    },
    resetDeliveryTime() {
      this.selectedDate = null;
      this.selectedTime = null;
    },
    getDeliveryFee() {
      if (this.streetAddress === null || this.streetAddress === '') {
        return;
      }
      if (i18n.locale !== 'en' && this.streetAddress.length < 6) {
        return;
      }

      this.deliveryFeeLoading = true;

      const data = {
        ...this.$route.query,
        brand_id: this.$route.params.brandId,
        store_id: this.$route.params.storeId,
        address: this.streetAddress,
        floor: this.floorAddress,
      };

      if (this.currentOrder.id) {
        data.order_id = this.currentOrder.id;
      }

      if (this.selectedOrderTime === 'SCHEDULED') {
        data.orderDatetime = this.productOrderTime;
      }

      Axios({
        method: 'post',
        url: '/cart/deliveryFee',
        data,
      })
        .then((response) => {
          if (response.data.code !== 500) {
            if (response.data.msg) {
              Swal.fire({
                text: response.data.msg,
              })
                .then(() => {
                  if (response.data.clearOrder) {
                    this.REMOVE_FROM_SAVED_ORDERS({
                      brand: this.$route.params.brandId,
                      store: this.$route.params.storeId,
                    });
                    this.RESET_CART();
                  }

                  if (response.data.reload) {
                    window.location.reload();
                  }

                  if (response.data.redirect) {
                    this.$router.push(response.data.redirect);
                  }
                });
            } else {
              if (response.data.clearOrder) {
                this.REMOVE_FROM_SAVED_ORDERS({
                  brand: this.$route.params.brandId,
                  store: this.$route.params.storeId,
                });
                this.RESET_CART();
              }

              if (response.data.reload) {
                window.location.reload();
              }

              if (response.data.redirect) {
                this.$router.push(response.data.redirect);
              }
            }

            this.deliveryFeeLoading = false;

            if (response.data.code === 498) {
              this.floorAddress = null;
            }
            return;
          }

          this.SET_CURRENT_ORDER({
            brand: this.$route.params.brandId,
            store: this.$route.params.storeId,
            id: response.data.data.id,
            property: response.data.data.property || null,
          });

          const deliveryFeeData = {
            provider: response.data.data.delivery_provider,
            fee: response.data.data.delivery_fee,
            distance: response.data.data.distance,
            discount: response.data.data.delivery_fee_discount,
            waitTime: response.data.data.waitTime,
          };

          if (response.data.data.free_delivery) {
            deliveryFeeData.freeDelivery = response.data.data.free_delivery;
          }

          if (response.data.data.delivery_minimum) {
            deliveryFeeData.minimum = response.data.data.delivery_minimum;
          }

          this.SET_CURRENT_ORDER_DELIVERY(deliveryFeeData);

          this.deliveryFeeLoading = false;
        });
    },
    selectOrderType(orderType) {
      if (this.fixOrderType) return;

      this.selectedOrderType = orderType;
    },
    selectPromo(index) {
      const hasCode = 'code' in this.promos[index];

      Swal.fire({
        html: `${this.promos[index].title}<br><br>${this.promos[index].content}`,
        showCancelButton: hasCode && ClipboardJS.isSupported(),
        cancelButtonText: this.$i18n.t('store.close'),
        confirmButtonText: hasCode && ClipboardJS.isSupported() ? this.$i18n.t('store.copyPromoCode') : this.$i18n.t('store.close'),
        customClass: {
          confirmButton: hasCode ? 'swal2-confirm--has-code' : '',
        },
        reverseButtons: true,
      })
        .then((result) => {
          if (!ClipboardJS.isSupported()) {
            return;
          }

          if (!hasCode) {
            return;
          }

          if (result.value) {
            const clipboard = new ClipboardJS('.swal2-confirm--has-code', {
              container: document.querySelector('.swal2-container'),
              text: () => this.promos[index].code,
            });

            clipboard.on('success', () => {
              this.$root.$message.success(`「${this.promos[index].code}」${this.$i18n.t('store.copied')}`);
            });
          }
        });
    },
    categoryStartWaypoint({ el, going, direction }) {
      if (!direction) {
        return;
      }

      if (this.categoryWaypointScrolling) {
        return;
      }

      if (this.keyword) {
        return;
      }

      if (going === this.$waypointMap.GOING_IN && direction === this.$waypointMap.DIRECTION_TOP) {
        this.showCategories = true;
        this.currentCategory = el.dataset.id;
      }
    },
    categoryEndWaypoint({ el, going, direction }) {
      if (!direction) {
        return;
      }

      if (this.categoryWaypointScrolling) {
        return;
      }

      if (this.keyword) {
        return;
      }

      if (going === this.$waypointMap.GOING_IN && direction === this.$waypointMap.DIRECTION_BOTTOM) {
        this.showCategories = true;
        this.currentCategory = el.dataset.id;
      }
    },
    selectCategoryPill(categoryId) {
      this.$scrollTo(
        `#Category-${categoryId}`,
        250,
        {
          offset: (-101 - 8),
          onStart: () => {
            this.categoryWaypointScrolling = true;
          },
          onDone: () => {
            this.categoryWaypointScrolling = false;
          },
        },
      );

      this.$nextTick(() => {
        this.currentCategory = `Category-${categoryId}`;
      });
    },
    itemCount(product) {
      if (!this.currentOrder.id) {
        return 0;
      }

      if (this.currentOrder.detail === null) {
        return 0;
      }

      if (this.currentOrder.id && this.currentOrder.detail.items) {
        // eslint-disable-next-line eqeqeq
        const match = this.currentOrder.detail.items.filter((item) => item.item_id === product.item_id);
        if (match.length > 0) {
          return match[0].count;
        }
      }
      return 0;
    },
    selectProduct(product) {
      if (this.orderUpdating || this.deliveryFeeLoading) {
        return;
      }

      if (product.soldOut === true) {
        return;
      }

      this.productModalProduct = product;
    },
    dateLabel(label) {
      return this.$moment(label).calendar({
        sameDay: `M/D [${this.$i18n.t('cart.today')}]`,
        nextDay: `M/D [${this.$i18n.t('cart.tomorrow')}]`,
        nextWeek: 'M/D ddd',
        sameElse: 'M/D ddd',
      });
    },
    goToCart(cartId) {
      // 運費區間檢查是否滿足低消
      if (this.currentOrder.id
        && this.currentOrder.detail
        && this.currentOrder.delivery
        && this.currentOrder.delivery.minimum
        && this.currentOrder.delivery.minimum > this.currentOrder.detail.subtotal
        && this.currentGroup.id === null
      ) {
        Swal.fire({
          text: `${this.$i18n.t('store.reminderDesc')} $${this.currentOrder.delivery.minimum}`,
          showCancelButton: true,
          confirmButtonText: this.$i18n.t('store.continue'),
          cancelButtonText: this.$i18n.t('store.viewCart'),
          reverseButtons: true,
        })
          .then((result) => {
            if (result.dismiss === Swal.DismissReason.cancel) {
              this.$router.push({
                name: 'Cart',
                params: {
                  cartId,
                },
                query: {
                  ...this.$route.query,
                },
              });
            }
          });
        return;
      }

      this.$router.push({
        name: 'Cart',
        params: {
          cartId,
        },
        query: {
          ...this.$route.query,
        },
      });
    },
    parseDistance(distance) {
      if (!distance) {
        return '0m';
      }

      if (distance < 1) {
        return `${(distance.toFixed(3) * 1000).toString()}m`;
      }

      if (distance < 10) {
        return `${distance.toFixed(2).toString()}km`;
      }

      if (distance < 50) {
        return `${distance.toFixed(1).toString()}km`;
      }

      return `${distance.toFixed(0).toString()}km`;
    },
    isValidDelivery() {
      const { provider, distance } = this.currentOrder.delivery || {};
      return !provider || distance !== -1;
    },
    isValidOrder() {
      const { subtotal, items } = this.currentOrder.detail || {};
      return !!(this.currentOrder.id && this.currentOrder.detail && (subtotal > 0 || (items && items.length > 0)));
    },
    isValidGroup() {
      return !!this.currentGroup.id;
    },
    showCheckout() {
      return !this.streetAddressError
      && this.isValidDelivery()
      && (this.isValidGroup() || this.isValidOrder());
    },
    updateOrder() {
      this.orderUpdating = true;
      this.deliveryFeeLoading = true;

      const data = {
        ...this.$route.query,
        brand_id: this.$route.params.brandId,
        order_id: this.currentOrder.id,
        orderType: this.selectedOrderType,
        orderTime: this.selectedOrderTime,
      };

      if (this.productOrderTime) {
        data.orderDatetime = this.productOrderTime;
      }

      return Axios({
        method: 'post',
        url: '/cart/update',
        data,
      })
        .then((response) => {
          if (response.data.code === 498) { // 地址錯誤
            Swal.fire({
              text: response.data.msg,
            })
              .then(() => {
                this.streetAddressError = true;
                this.floorAddress = null;
                this.$nextTick(() => {
                  this.orderUpdating = false;
                  this.deliveryFeeLoading = false;
                });
              });
            return;
          }

          if (response.data.code !== 500 && response.data.code !== 498) {
            if (response.data.msg) {
              Swal.fire({
                text: response.data.msg,
              })
                .then(() => {
                  this.$nextTick(() => {
                    this.orderUpdating = false;
                  });

                  if (response.data.clearOrder) {
                    this.REMOVE_FROM_SAVED_ORDERS({
                      brand: this.$route.params.brandId,
                      store: this.$route.params.storeId,
                    });
                    this.RESET_CART();
                  }

                  if (response.data.reload) {
                    window.location.reload();
                  }

                  if (response.data.redirect) {
                    this.$router.push(response.data.redirect);
                  }
                });
            } else {
              this.$nextTick(() => {
                this.orderUpdating = false;
                this.deliveryFeeLoading = false;
              });

              if (response.data.clearOrder) {
                this.REMOVE_FROM_SAVED_ORDERS({
                  brand: this.$route.params.brandId,
                  store: this.$route.params.storeId,
                });
                this.RESET_CART();
              }

              if (response.data.reload) {
                window.location.reload();
              }

              if (response.data.redirect) {
                this.$router.push(response.data.redirect);
              }
            }
          }

          if (response.data.data.brief && response.data.data.brief.delivery_provider) {
            const deliveryFeeData = {
              provider: response.data.data.brief.delivery_provider,
              fee: response.data.data.brief.delivery_fee,
              distance: response.data.data.brief.distance,
              discount: response.data.data.brief.delivery_fee_discount,
              waitTime: response.data.data.brief.waitTime,
            };

            if (response.data.data.brief.free_delivery) {
              deliveryFeeData.freeDelivery = response.data.data.brief.free_delivery;
            }

            if (response.data.data.brief.delivery_minimum) {
              deliveryFeeData.minimum = response.data.data.brief.delivery_minimum;
            }

            this.SET_CURRENT_ORDER_DELIVERY(deliveryFeeData);
          } else {
            this.RESET_CURRENT_ORDER_DELIVERY();
          }

          this.$nextTick(() => {
            this.orderUpdating = false;
            this.deliveryFeeLoading = false;
          });
        });
    },
    goWdOrder() {
      this.$router.push({ name: 'WdOrder', params: { cartId: this.currentOrder.id }, query: { ...this.$route.query } });
    },
    selectFirstAvailableOrderTime(orderType) {
      const availableOrderTime = this.store.order_setting[orderType].time.filter((time) => time.disable === undefined);

      if (availableOrderTime.length > 0) {
        this.selectedTime = availableOrderTime[0].value;
      } else {
        this.selectedTime = null;
      }
    },
  },
  beforeMount() {
    const data = {
      ...this.$route.query,
      brand_id: this.$route.params.brandId,
      store_id: this.$route.params.storeId,
    };

    if (this.$route.params.brandId === this.currentOrder.brand && this.$route.params.storeId === this.currentOrder.store && this.currentOrder.id) {
      data.order_id = this.currentOrder.id;
    } else if (this.savedOrders[this.$route.params.brandId] && this.savedOrders[this.$route.params.brandId][this.$route.params.storeId]) {
      // eslint-disable-next-line prefer-destructuring
      data.order_id = this.savedOrders[this.$route.params.brandId][this.$route.params.storeId];
    } else {
      this.RESET_CURRENT_ORDER();
    }

    if (this.$route.query.group) {
      data.group_id = this.$route.query.group;
    }

    Axios({
      method: 'post',
      url: '/store/get',
      data,
    })
      .then((response) => {
        if (response.data.code !== 500) {
          if (response.data.msg) {
            Swal.fire({
              text: response.data.msg,
            })
              .then(() => {
                if (response.data.clearOrder) {
                  this.REMOVE_FROM_SAVED_ORDERS({
                    brand: this.$route.params.brandId,
                    store: this.$route.params.storeId,
                  });
                  this.RESET_CART();
                }

                if (response.data.reload) {
                  window.location.reload();
                }

                if (response.data.redirect) {
                  this.$router.push(response.data.redirect);
                }

                if (response.data.code === 497) { // 團購訂單 ID 不正確
                  this.RESET_CURRENT_GROUP();
                  this.$router.push({ query: null });
                  window.location.reload();
                }
              });
          } else {
            if (response.data.code === 498) { // 團購訂單 ID 與現有訂單 ID 不相符
              this.REMOVE_FROM_SAVED_ORDERS({
                brand: this.$route.params.brandId,
                store: this.$route.params.storeId,
              });
              this.RESET_CART();
              window.location.reload();
            }

            if (response.data.clearOrder) {
              this.REMOVE_FROM_SAVED_ORDERS({
                brand: this.$route.params.brandId,
                store: this.$route.params.storeId,
              });
              this.RESET_CART();
            }

            if (response.data.reload) {
              window.location.reload();
            }

            if (response.data.redirect) {
              this.$router.push(response.data.redirect);
            }
          }
          return;
        }

        if (response.data.data.name === response.data.data.branch) {
          document.title = `${response.data.data.name} | ${this.$i18n.t('home.OcardOnlineOrdering')}`;
        } else {
          document.title = `${response.data.data.branch} - ${response.data.data.name} | ${this.$i18n.t('home.OcardOnlineOrdering')}`;
        }

        if (response.data.data.order_setting === null) {
          Swal.fire({
            text: `${response.data.data.name} ${this.$i18n.t('store.unAvailable')}`,
            showCancelButton: true,
            confirmButtonText: this.$i18n.t('store.back'),
            cancelButtonText: this.$i18n.t('store.viewOrders'),
            reverseButtons: true,
          })
            .then((result) => {
              if (result.dismiss === Swal.DismissReason.cancel) {
                this.$router.push({ name: 'Orders' });
              } else {
                this.$router.push({ name: 'Brand' });
              }
            });
          return;
        }

        this.SET_STORE(response.data.data);

        if (response.data.data.order) {
          this.SET_CURRENT_ORDER({
            brand: this.$route.params.brandId,
            store: this.$route.params.storeId,
            id: response.data.data.order.id,
            property: response.data.data.order.property || null,
          });
          this.SET_CART(response.data.data.order);
          this.selectedOrderType = this.currentOrder.detail.orderType;

          this.selectedOrderTime = this.currentOrder.detail.orderTime;
          const orderTime = this.currentOrder.detail.orderDatetime;

          if (orderTime) {
            this.selectedDate = this.$moment(orderTime).format('YYYY-MM-DD');
            this.selectedTime = this.$moment(orderTime).format('HH:mm');
          }

          this.streetAddress = this.currentOrder.detail.address;
        }

        if (!this.currentOrder.id) {
          if (this.store.order_setting.DELIVERY) {
            this.selectedOrderType = 'DELIVERY';
          } else if (this.store.order_setting.PICKUP) {
            this.selectedOrderType = 'PICKUP';
          } else if (this.store.order_setting.INSTORE) {
            this.selectedOrderType = 'INSTORE';
          }

          if (this.selectedOrderType === 'DELIVERY') {
            // eslint-disable-next-line prefer-destructuring
            this.selectedOrderTime = this.store.order_setting.DELIVERY.orderTime[0];

            if (this.selectedOrderTime === 'SCHEDULED') {
              this.selectedDate = this.store.order_setting.DELIVERY.date[0].value;
              this.selectFirstAvailableOrderTime('DELIVERY');
            }
          } else if (this.selectedOrderType === 'PICKUP') {
            // eslint-disable-next-line prefer-destructuring
            this.selectedOrderTime = this.store.order_setting.PICKUP.orderTime[0];

            if (this.selectedOrderTime === 'SCHEDULED') {
              this.selectedDate = this.store.order_setting.PICKUP.date[0].value;
              this.selectFirstAvailableOrderTime('PICKUP');
            }
          } else if (this.selectedOrderType === 'INSTORE') {
            // eslint-disable-next-line prefer-destructuring
            this.selectedOrderTime = this.store.order_setting.INSTORE.orderTime[0];

            if (this.selectedOrderTime === 'SCHEDULED') {
              this.selectedDate = this.store.order_setting.INSTORE.date[0].value;
              this.selectFirstAvailableOrderTime('INSTORE');
            }
          }
        }

        if (response.data.data.group) {
          this.SET_CURRENT_GROUP({
            brand: this.$route.params.brandId,
            store: this.$route.params.storeId,
            id: response.data.data.group.id,
            host: response.data.data.group.host.name,
            owner: response.data.data.group.owner,
          });

          if (response.data.data.group.owner === false && !this.currentOrder.id) {
            this.showGroup = true;
          }
        } else {
          this.RESET_CURRENT_GROUP();
        }

        this.$nextTick(() => {
          this.storeLoaded = true;
        });

        this.getMenu();
      });
  },
};
</script>

<style lang="sass" scoped>
.group-banner
  display: flex
  align-items: center

  .content
    flex-grow: 1

.store
  &__banner
    padding-top: calc(3 / 4 * 100%)
    top: 64px
    right: 0
    left: 0

    z-index: -1

    &.is-shifted
      top: 92px

    &-overlay
      right: 0
      bottom: 0
      left: 0
      height: $size-m

  &__header
    margin-top: calc((3 / 4 * 100%) - 100px)

  &__logo
    width: 150px
    height: 150px

  &__branch
    display: flex
    align-items: center
    justify-content: center

  &__info
    display: flex
    align-items: center

    color: currentcolor
    text-decoration: none

  &__info
    &__announce
      position: relative

      &::after
        position: absolute
        top: 0
        bottom: 0
        left: 0
        height: 100%
        width: $size-xxs

        @extend .BDRS-tr-m
        @extend .BDRS-br-m

        background-color: $color-brand

        content: ''

      .announce
        &-title
          display: flex
          align-items: center

        &-content
          ::v-deep a
            color: currentcolor
            text-decoration: underline

          ::v-deep img
            max-width: 100%

          ::v-deep *:not(:first-child)
            display: none

          ::v-deep *:first-child
            overflow: hidden
            display: -webkit-box
            -webkit-line-clamp: 1
            -webkit-box-orient: vertical

      .more
        flex-shrink: 1

        border: none

        appearance: none
        outline: none

    &__desc
      white-space: pre-wrap

      ::v-deep ul
        margin: 0
        padding: 0
        padding-left: 1.5em

      ::v-deep ul li ul
        list-style-type: none
        margin: 0
        padding: 0

    &__tab
      display: flex

      &.is-fixed
        .tab
          display: none

          &.is-active
            display: flex

  &__categories
    top: 40px
    right: 0
    left: 0
    z-index: $z-index-sticky

    border-bottom: 2px solid $color-light

    background-color: white

    transition: top $time-fast $cb

    &.is-shifted
      top: 64px

    &__wrapper
      overflow-x: auto
      -webkit-overflow-scrolling: touch
      -ms-overflow-style: -ms-autohiding-scrollbar

      white-space: nowrap

      &::-webkit-scrollbar
        display: none

    &__item
      overflow: hidden
      display: inline-block
      list-style-type: none
      vertical-align: middle
      padding: $size-s 0
      max-width: 75%
      @extend .MR-m
      @extend .ML-m

      white-space: nowrap
      text-overflow: ellipsis

      cursor: pointer

      &.is-current
        @extend .C-dark
        @extend .FW-b

        &::after
          height: 6px
          position: absolute
          right: 0
          bottom: 0
          left: 0

          border-radius: 6px 6px 0 0

          content: ''

          @extend .BGC-brand

  &__menu
    .view-tools
      display: flex

      .search-form
        flex-grow: 1

  &__products
    &--list
      &__product
        &:not(:nth-last-child(-n+2))
          &::after
            position: absolute
            bottom: 0
            left: 8px
            right: 8px
            height: 1px

            background-color: $color-light

            content: ''

            @media only screen and (min-device-pixel-ratio: 2), only screen and (min-resolution: 192dpi)
              height: .5px

              background-color: $color-light-grey

    &--grid
      display: flex
      flex-wrap: wrap

.fill-address
  overflow: scroll
  overflow-y: hidden
  white-space: nowrap

  &::-webkit-scrollbar
    width: 0

  .address-item
    &:last-child
      @extend .MR-m

.delivery-fee, .delivery-wait-time
  display: flex
  flex-direction: row
  justify-content: space-between
  align-items: center
  box-shadow: 0 1px 4px rgba(0, 0, 0, .25)

  &.free-of-charge
    display: none

  &.free-of-charge.too-far
    display: flex

  .info
    flex-grow: 1

  .loader
    position: absolute
    top: 0
    right: 0
    bottom: 0
    left: 0
    display: flex
    justify-content: center
    align-items: center

    @extend .BDRS-99

    background-color: inherit

    span
      display: inline-block
      width: 10px
      height: 10px
      border-radius: 100%
      background-color: #575757
      margin: 0 $size-xxs
      opacity: 0

      &:nth-child(1)
        animation: opacitychange .5s ease-in-out infinite

      &:nth-child(2)
        animation: opacitychange .5s ease-in-out .166666667s infinite

      &:nth-child(3)
        animation: opacitychange .5s ease-in-out .333333334s infinite

      @keyframes opacitychange
        0%, 100%
          opacity: 0

        60%
          opacity: 1

.disabled-hours
  box-shadow: 0 1px 4px rgba(0, 0, 0, .25)

.promos
  .promo
    &.has-multi
      margin-bottom: 8px

    &-title
      display: flex
      align-items: center

    &-content
      overflow: hidden
      text-overflow: ellipsis
      display: -webkit-box
      -webkit-line-clamp: 2
      -webkit-box-orient: vertical

  ::v-deep .promos-pagination
    bottom: 0

  ::v-deep .swiper-pagination-bullet
    margin: 0 2px
    opacity: .5

    background-color: $color-brand

.animate
  transition-delay: $time-fast
  transition-property: transform, opacity
  transition-duration: $time-long
  transition-timing-function: $cb

.category-enter
  transform: translateY(50px)
  opacity: 0

  &.animate-active
    transform: translateY(0)
    opacity: 1

.footer
  display: flex
  bottom: 0
  padding-bottom: env(safe-area-inset-bottom)
  z-index: $z-index-sticky

  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, white 100%)

  user-select: none

  .go-to-cart
    flex-grow: 1

  .readonly-for
    flex-grow: 1
    padding: 14px $size-s

    border: none

    @extend .BGC-light-grey

    @extend .FW-b
    @extend .C-dark
    @extend .TA-c

.ocard
  .terms
    a
      color: currentcolor
      text-decoration: underline
</style>
